import { AchievnmentItemType } from "../../../utility/types/generaTypes";
import "./AchievementCard.css";

type AchievementCardProps = {
  achivenment: AchievnmentItemType;
  mainContainerClassname?: string;
};
const AchievementCard = ({
  achivenment,
  mainContainerClassname,
}: AchievementCardProps) => {
  return (
    <div className={`achievementCard_container ${mainContainerClassname}`}>
      <h3>{achivenment?.count}</h3>
      <p>{achivenment?.label}</p>
    </div>
  );
};

export default AchievementCard;
